<template>
	<div class="backBtn mobileMargin-b15">
		<router-link :to="to" class="cursor-default">
			<p class="textUppercase textGrey textXsml fontHeavy hover:text-[#555555] dark:hover:text-[#eeeeee]">
				<span class="fa-light fa-arrow-left textGrey"></span> {{ label || 'Take me back' }}
			</p>
		</router-link>
	</div>
</template>

<script>
export default {
	props: {
		to: {
			type: String,
			required: true
		},
		label: String
	}
}
</script>
